// Single dashed drop target cell inside the inbox triage grid.
import { Box, Paper, Typography } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';
import { useT } from '@/i18n/useT';

export default function InboxDropzone({
  id,
  label,
  highlighted = false,
  showDropHint = false,
  empty = true,
  tabIndex = -1,
  isKeyboardFocused = false,
  onRovingFocus,
}) {
  const t = useT();
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: { type: 'inbox-dropzone' },
  });

  const zoneAriaLabel = t(
    'inboxdropzone.zoneAriaLabel',
    '{label} drop zone',
    { label },
  );

  const showFocusRing = isKeyboardFocused && !isOver;

  return (
    <Paper
      ref={setNodeRef}
      variant="outlined"
      component="div"
      role="button"
      tabIndex={tabIndex}
      aria-label={zoneAriaLabel}
      data-testid={`inbox-dropzone-${id}`}
      onFocus={onRovingFocus}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 72,
        borderStyle: 'dashed',
        borderColor: isOver
          ? 'primary.main'
          : highlighted
            ? 'warning.main'
            : 'divider',
        bgcolor: isOver
          ? 'action.hover'
          : highlighted
            ? 'action.selected'
            : 'background.default',
        transition: 'border-color 0.15s ease, background-color 0.15s ease',
        outline: showFocusRing ? '2px solid' : 'none',
        outlineColor: showFocusRing ? 'primary.main' : 'transparent',
        outlineOffset: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          px: 1,
          textAlign: 'center',
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        {showDropHint && empty ? (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
            {t('inboxdropzone.dropHint', 'Sleep een taak hierheen')}
          </Typography>
        ) : null}
      </Box>
    </Paper>
  );
}
